import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { searchContent } from "@/lib/api";
import ContentCard from "@/components/ContentCard";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) { setResults([]); return; }
    setLoading(true);
    searchContent(q).then(r => setResults(r.results || [])).finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="pt-16" data-testid="search-page">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-10">
        <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-2">Search</p>
        <h1 className="font-heading text-4xl md:text-5xl font-bold mb-8" data-testid="search-heading">
          {q ? <>Results for <span className="text-[#D4AF37]">"{q}"</span></> : "Search VOTLiving"}
        </h1>
        {loading && <p className="text-white/50">Searching…</p>}
        {!loading && q && results.length === 0 && <p className="text-white/50" data-testid="no-results">No results found. Try another keyword.</p>}
        <div className="flex flex-wrap gap-4">
          {results.map(r => <ContentCard key={r.id} item={r} />)}
        </div>
      </div>
    </div>
  );
}
